import { Loader2 } from "lucide-react";
import { Link } from "react-router";

import { Card, CardContent } from "@/components/ui/card";
import { useAdminActivityActions, useAdminActivityAnalytics, useAdminUsers } from "@/lib/api";

import { ActivityDashboard } from "./activity-dashboard";

export function AdminActivityPage() {
  const analyticsQuery = useAdminActivityAnalytics(30);
  const usersQuery = useAdminUsers();
  const actionsQuery = useAdminActivityActions();

  const isLoading = analyticsQuery.isLoading || usersQuery.isLoading || actionsQuery.isLoading;
  const isError = analyticsQuery.isError || usersQuery.isError || actionsQuery.isError;

  return (
    <div className="mx-auto max-w-5xl px-6 py-8">
      {isLoading ? (
        <Card>
          <CardContent className="flex justify-center py-12">
            <Loader2 className="text-muted h-6 w-6 animate-spin" />
          </CardContent>
        </Card>
      ) : isError || !analyticsQuery.data ? (
        <Card>
          <CardContent className="py-8 text-center">
            <p className="text-muted text-sm">
              Could not load activity. Please{" "}
              <button
                type="button"
                onClick={() => {
                  void analyticsQuery.refetch();
                  void usersQuery.refetch();
                  void actionsQuery.refetch();
                }}
                className="underline"
              >
                try again
              </button>{" "}
              or{" "}
              <Link to="/home" className="underline">
                go back
              </Link>
              .
            </p>
          </CardContent>
        </Card>
      ) : (
        <ActivityDashboard
          analytics={analyticsQuery.data}
          users={usersQuery.data ?? []}
          actions={actionsQuery.data ?? []}
        />
      )}
    </div>
  );
}
